import { render, staticRenderFns } from "./regular-button.vue?vue&type=template&id=27aa0e66&scoped=true&lang=pug"
import script from "./regular-button.vue?vue&type=script&lang=js"
export * from "./regular-button.vue?vue&type=script&lang=js"
import style0 from "./regular-button.vue?vue&type=style&index=0&id=27aa0e66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27aa0e66",
  null
  
)

export default component.exports